
import {useState} from 'nuxt/app';
import {computed, Ref} from "vue";
import {useFetchWithJwt} from "~/composables/useFetchWithJwt";
import {ApiResponse, ApiResponseWithPage, PageData, RawItem, RawItemPrevious, RegisterMappingItem} from "~/types/response";

export function usePasswordDialog() {
    const { fetchWithJwt } = useFetchWithJwt();
    const passwordCheckResult = useState<number>('passwordCheckResult', () => 0);

    const fetchPasswordCheck = async (password: string): Promise<ApiResponse<any>> => {
        return (await fetchWithJwt('/user/check/password', {
            method: 'POST',
            body: JSON.stringify({ password }),
        })) as ApiResponse<any>;
    };

    // ★ 수정된 handlePasswordCheck: boolean 반환
    const handlePasswordCheck = async (password: string): Promise<boolean> => {
        console.log('[usePasswordDialog.ts] handlePasswordCheck 함수 시작');
        const response = await fetchPasswordCheck(password);
        if (response?.result === 'success') {
            passwordCheckResult.value = 1;
            console.log('[usePasswordDialog.ts] handlePasswordCheck 함수 종료');
            return true;
        } else {
            passwordCheckResult.value = 0;
            console.log('[usePasswordDialog.ts] handlePasswordCheck 함수 종료');
            return false;
        }
    };

    return {
        passwordCheckResult,
        fetchPasswordCheck,
        handlePasswordCheck,
    };
}
